import type { FilterGroupItem, FilterItem, SavedFilter } from './filterSettings';

export type SavedFilterNameValidation = { ok: true } | { ok: false; reason: 'empty' | 'duplicate' };

/**
 * Validates a proposed saved-filter name: non-empty after trimming and not a
 * case-insensitive duplicate of an existing saved filter's label.
 */
export function isValidSavedFilterName(name: string, existing: SavedFilter[]): SavedFilterNameValidation {
  const trimmed = name.trim();
  if (trimmed.length === 0) {
    return { ok: false, reason: 'empty' };
  }
  const lowered = trimmed.toLowerCase();
  if (existing.some((saved) => saved.label.trim().toLowerCase() === lowered)) {
    return { ok: false, reason: 'duplicate' };
  }
  return { ok: true };
}

/**
 * Removes incomplete items from a filter group so a saved set stores the same cleaned
 * shape that "Apply" persists: lines without a chosen filter type are dropped, and empty
 * groups are pruned. Recurses into nested groups.
 */
export function cleanFilterGroup(group: FilterGroupItem): FilterGroupItem {
  const filteredItems = group.items
    .map((item) => {
      if (item.type === 'group') {
        return cleanFilterGroup(item);
      }
      return item.filterType ? item : null;
    })
    .filter((item): item is FilterItem => item !== null && (item.type === 'line' || item.items.length > 0));

  return { ...group, items: filteredItems };
}
